module.exports = __webpack_public_path__ + "img/lecture_default.228ddf99.png";